import { Card, Space, Tag, Typography } from "antd";
import { problemItems, solutionItems } from "../landingData";

const { Title, Text } = Typography;

export function ProblemSolutionSection() {
  return (
    <section className="landing-section landing-muted">
      <div className="landing-problem-solution-grid">
        <div className="landing-problem-column">
          <Tag color="red">The Old Way</Tag>
          <Title level={2}>You're Losing Time Every Month</Title>

          <Space direction="vertical" size="middle" className="full-width">
            {problemItems.map((item) => (
              <Card key={item.problem} className="loss-card">
                <div className="split-row">
                  <Text strong>{item.problem}</Text>
                  <Text type="danger" strong>{item.amount}</Text>
                </div>
              </Card>
            ))}
          </Space>

          <div className="totals-callout loss-total">
            <Text strong className="totals-headline">Total Monthly Loss: $3,000+</Text>
            <Text className="totals-sub">That's $36,000 per year down the drain.</Text>
          </div>
        </div>

        <div className="landing-problem-column">
          <Tag color="green">The Hairplane Way</Tag>
          <Title level={2}>Recover Revenue and Time</Title>

          <Space direction="vertical" size="middle" className="full-width">
            {solutionItems.map((item) => (
              <Card key={item.solution} className="gain-card">
                <div className="split-row">
                  <Text strong>{item.solution}</Text>
                  <Text className="success-text" strong>{item.saved}</Text>
                </div>
              </Card>
            ))}
          </Space>

          <div className="totals-callout gain-total">
            <Text strong className="totals-headline">Total Monthly Gain: $3,000+</Text>
            <Text className="totals-sub">Plus you save 15 hours per week. That's priceless.</Text>
          </div>
        </div>
      </div>
    </section>
  );
}